import { useTranslation } from 'react-i18next'

import styles from '../ProgramDetail.module.scss'

import { ProgramDetailRow } from './Shared/ProgramDetailRow'
import { ValidationSubmissionConfigurationResponse } from '@percent/admin-dashboard/api/actions/validationSubmissions/validationSubmissions.types'
import { Badge, Flex, Typography, Color } from '@percent/lemonade'

export function ProgramOthers({
  primaryColor,
  programWebsite,
  configuration
}: ValidationSubmissionConfigurationResponse) {
  const { t } = useTranslation()

  return (
    <>
      <Typography variant="h2">{t('typography.other')}</Typography>
      <Flex gap={16} direction="column">
        <ProgramDetailRow title={t('program.label.primaryColor')}>
          <Badge variant="default">
            {primaryColor ? (
              <Flex align="center" gap={8}>
                <span className={styles.primaryColorBox} style={{ backgroundColor: primaryColor as Color }} />
                <p>{primaryColor}</p>
              </Flex>
            ) : (
              t('status.na')
            )}
          </Badge>
        </ProgramDetailRow>
        <ProgramDetailRow title={t('program.label.programWebsite')}>
          <Badge variant="default">
            {programWebsite ? (
              <a
                href={programWebsite?.startsWith('https') ? programWebsite : `https://${programWebsite}`}
                target="_blank"
                rel="noreferrer"
              >
                {programWebsite}
              </a>
            ) : (
              t('status.na')
            )}
          </Badge>
        </ProgramDetailRow>
        <ProgramDetailRow
          title={t('program.label.captchaMandatory')}
          status={configuration?.captchaMandatory ? 'on' : 'off'}
        />
      </Flex>
    </>
  )
}
